import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'

import { AppLinearProgress, AppLinksBlock } from '@components'
import { REPORT_STATUS } from '@constants'
import { LoadingText } from 'Pages/Main/Home/@components'
import { useReportsHomeData } from 'Pages/Main/Home/@hooks'
import { homeRunningExecutions, homeRunningStatus } from 'Pages/Main/Home/@signals'
import { reportSearchesModalId } from '@signals'


// The row does not poll: it registers its execution in homeRunningExecutions and reads its
// status from homeRunningStatus, filled by the single status-multiple poll of the table.
export default function ReportHomeListTableRunningBlock({ rowData }) {
	const idReport = rowData.idReport
	const idExecution = rowData.idLastExecution
	const isRunning = rowData.statusLastExecution === REPORT_STATUS.RUNNING

	const { setReportData } = useReportsHomeData()

	useEffect(() => {
		if (!isRunning || !idExecution) return
		if (!homeRunningExecutions.value.includes(idExecution)) {
			homeRunningExecutions.value = [ ...homeRunningExecutions.value, idExecution ]
		}
		return () => {
			homeRunningExecutions.value = homeRunningExecutions.value.filter(id => id !== idExecution)
		}
	}, [ idExecution, isRunning ])

	const status = homeRunningStatus.value[idExecution] || {}
	const completed = !!status.ExecutionGlobalStatusCompleted
	const isGenerating = !!status.generating
	const showAnalyzers = !!(status.ready || completed)

	useEffect(() => {
		if (completed) setReportData({ idReport: idReport, statusLastExecution: REPORT_STATUS.READY })
	}, [ completed ])

	return <Box
		sx={{
			cursor: !isGenerating ? 'pointer' : '',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			width: 1,
		}}
		onClick={() => {
			if (!isGenerating) {
				reportSearchesModalId.value = idExecution
			}
		}}>
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 1, mb: 0.5 }}>
			<LoadingText label={!isGenerating ? 'Running' : 'Generating'}/>
			{!isGenerating && <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
				{status.completeTasksString || 0}/{status.totalTasksString || 0}
			</Typography>}
		</Box>
		<Box sx={{ width: 1 }}>
			<AppLinearProgress actual={status.percentage || 0} total={100} generating={isGenerating}/>
		</Box>
		{showAnalyzers && <Box sx={{ mt: 1 }}>
			<AppLinksBlock
				reportExecutionID={status.idReportExecution || idExecution}
				downMultiReport={!!status.executionHasGenerations}
				downMultiExport={!!status.executionHasExports}
				hasCompetitionSites={rowData.hasCompetitionSites}
				hasDirectSites={rowData.hasDirectSites}
			/>
		</Box>}
		<Box sx={{ width: 1 }}>
			<Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem', textAlign: 'center' }}>
				{!isGenerating && 'Click progress bar to view details'}
			</Typography>
		</Box>
	</Box>
}
